import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const RL31Visual = () => (
  <Box sx={{ maxWidth: 800, mx: 'auto', my: 4 }}>
    <Box
      component="svg"
      role="img"
      aria-label="Ejemplo RL-31 Quebec para reclamar Solidarity Tax Credit 2026"
      viewBox="0 0 760 360"
      sx={{ width: '100%', height: 'auto', display: 'block' }}
    >
      {/* Document background */}
      <rect x="20" y="0" width="720" height="350" rx="8" fill="#fff" stroke="#E6E9EE" strokeWidth="2" />

      {/* Header */}
      <rect x="20" y="0" width="720" height="48" rx="8" fill="#1A1A1A" />
      <rect x="20" y="24" width="720" height="24" fill="#1A1A1A" />
      <text x="380" y="30" textAnchor="middle" fill="#fff" fontSize="13" fontWeight="600" fontFamily="Inter, sans-serif">
        RL-31 - Relevé 31: Renseignements sur un logement / Housing Information
      </text>

      {/* Year badge */}
      <rect x="630" y="58" width="96" height="28" rx="4" fill="#F7F9FC" stroke="#E6E9EE" />
      <text x="678" y="77" textAnchor="middle" fill="#1A1A1A" fontSize="13" fontWeight="600" fontFamily="Inter, sans-serif">
        2025
      </text>

      {/* Landlord info section */}
      <rect x="40" y="96" width="330" height="52" rx="6" fill="#F7F9FC" stroke="#E6E9EE" strokeWidth="1.5" />
      <text x="54" y="114" fill="#5F6B7A" fontSize="9.5" fontWeight="600" fontFamily="Inter, sans-serif">
        Nom du locateur / Landlord name
      </text>
      <text x="54" y="135" fill="#1A1A1A" fontSize="14" fontWeight="600" fontFamily="Inter, sans-serif">
        Jean-Pierre Tremblay
      </text>

      {/* Address section */}
      <rect x="390" y="96" width="338" height="52" rx="6" fill="#F7F9FC" stroke="#E6E9EE" strokeWidth="1.5" />
      <text x="404" y="114" fill="#5F6B7A" fontSize="9.5" fontWeight="600" fontFamily="Inter, sans-serif">
        Adresse du logement / Address
      </text>
      <text x="404" y="135" fill="#1A1A1A" fontSize="14" fontWeight="600" fontFamily="Inter, sans-serif">
        4521 Rue Saint-Denis, Montreal, QC
      </text>

      {/* === Case A - Loyer payé (GOLD highlight) === */}
      <rect x="40" y="166" width="340" height="62" rx="6" fill="#FFF8E1" stroke="#7D5A00" strokeWidth="2.5" />
      <text x="54" y="186" fill="#7D5A00" fontSize="10" fontWeight="600" fontFamily="Inter, sans-serif">
        Case A - Loyer payé / Rent paid
      </text>
      <text x="54" y="213" fill="#7D5A00" fontSize="22" fontWeight="600" fontFamily="Inter, sans-serif">
        $10,800.00
      </text>
      {/* Label */}
      <text x="400" y="200" fill="#7D5A00" fontSize="12" fontWeight="600" fontFamily="Inter, sans-serif">
        Renta anual total pagada
      </text>

      {/* === Numero du logement (RED warning) === */}
      <rect x="40" y="246" width="340" height="58" rx="6" fill="#FFEBEE" stroke="#D32F2F" strokeWidth="2.5" />
      <text x="54" y="264" fill="#D32F2F" fontSize="10" fontWeight="600" fontFamily="Inter, sans-serif">
        Numéro du logement / Housing number
      </text>
      <text x="54" y="289" fill="#D32F2F" fontSize="20" fontWeight="600" fontFamily="Inter, sans-serif">
        MTL-2025-44782
      </text>

      {/* Red warning arrow and text */}
      <line x1="385" y1="275" x2="420" y2="275" stroke="#D32F2F" strokeWidth="2.5" markerEnd="url(#arrowRed31)" />
      <text x="428" y="268" fill="#D32F2F" fontSize="11" fontWeight="600" fontFamily="Inter, sans-serif">
        Sin este número no puedes
      </text>
      <text x="428" y="284" fill="#D32F2F" fontSize="11" fontWeight="600" fontFamily="Inter, sans-serif">
        reclamar el Solidarity Credit
      </text>

      {/* Case B - Taxes municipales */}
      <rect x="400" y="166" width="328" height="62" rx="6" fill="#F7F9FC" stroke="#E6E9EE" strokeWidth="1.5" />
      <text x="414" y="186" fill="#5F6B7A" fontSize="9.5" fontWeight="600" fontFamily="Inter, sans-serif">
        Case B - Taxes municipales et scolaires
      </text>
      <text x="414" y="213" fill="#5F6B7A" fontSize="17" fontWeight="600" fontFamily="Inter, sans-serif">
        N/A (inquilino)
      </text>

      {/* Period */}
      <rect x="400" y="246" width="328" height="58" rx="6" fill="#F7F9FC" stroke="#E6E9EE" strokeWidth="1.5" />
      <text x="414" y="264" fill="#5F6B7A" fontSize="9.5" fontWeight="600" fontFamily="Inter, sans-serif">
        Période de location / Rental period
      </text>
      <text x="414" y="289" fill="#5F6B7A" fontSize="17" fontWeight="600" fontFamily="Inter, sans-serif">
        2025-01-01 al 2025-12-31
      </text>

      {/* Legend */}
      <rect x="40" y="322" width="14" height="14" rx="3" fill="#FFF8E1" stroke="#7D5A00" strokeWidth="1.5" />
      <text x="62" y="333" fill="#1A1A1A" fontSize="11" fontFamily="Inter, sans-serif">
        Renta pagada (componente vivienda del Solidarity Credit)
      </text>

      <rect x="400" y="322" width="14" height="14" rx="3" fill="#FFEBEE" stroke="#D32F2F" strokeWidth="1.5" />
      <text x="422" y="333" fill="#1A1A1A" fontSize="11" fontFamily="Inter, sans-serif">
        Numero de vivienda (obligatorio para solicitar)
      </text>

      <defs>
        <marker id="arrowRed31" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
          <path d="M0,0 L8,3 L0,6 Z" fill="#D32F2F" />
        </marker>
      </defs>
    </Box>
    <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', color: '#5F6B7A', mt: 1 }}>
      Ejemplo ilustrativo - valores ficticios. Tu propietario debe entregarte el RL-31 antes de fin de febrero.
    </Typography>
  </Box>
);

export default RL31Visual;
